import React from 'react';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import TransactionConstants from '@common/constants/TransactionConstants';
import { centsToDollars } from '@common/paymentsUtils/currencyUtils';
import { formatDate } from '@common/paymentsUtils/dateUtils';
import MoveInCostsTypes from '@common/constants/MoveInCostsConstants';
import DetailsCard from '@rental-manager/components/DetailsCard';
import type { AllTransactionInterface, IFeaturePermissionModel, IRentTermsModel } from '@rental-manager/models/Types';
import type { EditMoveInCostsInterface } from '@rental-manager/pages/Dashboard/types';
import FeaturePermissionTypes from '@rental-manager/constants/FeaturePermissionTypes';
import { getMoveInCostsDetails } from '@common/paymentsUtils/moveInCostsUtil';

interface MoveInCostsProps {
  rentTerms: IRentTermsModel;
  allTransactions: AllTransactionInterface;
  addMoveInCosts: (term: string) => void;
  featurePermissions: IFeaturePermissionModel;
  cancelMoveInCostsModal: ({ term, rentTermsKey }: EditMoveInCostsInterface) => void;
  term: string;
}

class MoveInCosts extends React.Component<MoveInCostsProps> {
  cancelMoveInCostsModal = (): void => {
    const { term, rentTerms } = this.props;
    const { rentTermsKey } = rentTerms;
    this.props.cancelMoveInCostsModal({ term, rentTermsKey });
  };

  addMoveInCosts = (): void => {
    const { term } = this.props;
    this.props.addMoveInCosts(term);
  };

  render(): React.ReactNode {
    const { rentTerms, allTransactions } = this.props;
    const { rentTermsKey } = rentTerms;
    const moveInCostsInfo = getMoveInCostsDetails(allTransactions, rentTermsKey);
    const isMoveInCostsPresent =
      moveInCostsInfo && moveInCostsInfo.moveInCostsItems && moveInCostsInfo.moveInCostsItems.length !== 0;
    const isMICUnpaid =
      isMoveInCostsPresent &&
      (moveInCostsInfo.landlordStatus === TransactionConstants.STATUS.UNPAID ||
        moveInCostsInfo.landlordStatus === TransactionConstants.STATUS.PAST_DUE);
    const { isAllowed: isMICAllowed } =
      this.props.featurePermissions?.[rentTermsKey]?.[FeaturePermissionTypes.MOVE_IN_COSTS] || false;
    const renderIfWithin2PaymentsOrCancelable = isMICUnpaid || isMICAllowed;

    return (
      (renderIfWithin2PaymentsOrCancelable && (
        <DetailsCard
          className="fs-exclude"
          title="Move-in costs"
          showEdit={isMICUnpaid || !isMoveInCostsPresent}
          buttonTitle={isMICUnpaid ? 'Cancel' : 'Add'}
          onEdit={isMICUnpaid ? this.cancelMoveInCostsModal : this.addMoveInCosts}
        >
          <Text>Total: {isMoveInCostsPresent ? centsToDollars(moveInCostsInfo.amount) : '$0'}</Text>
          {isMoveInCostsPresent &&
            moveInCostsInfo.moveInCostsItems.map((moveInCostItem, i: number) => (
              <Text key={i.toString()}>
                {!moveInCostItem.subType && (
                  <Text>
                    {MoveInCostsTypes[moveInCostItem.type]}: {centsToDollars(moveInCostItem.amount)}
                  </Text>
                )}
                {moveInCostItem.subType && (
                  <Text>
                    {moveInCostItem.subType}: {centsToDollars(moveInCostItem.amount)}
                  </Text>
                )}
              </Text>
            ))}
          {isMoveInCostsPresent && <Text>Due date: {formatDate(moveInCostsInfo.dueDate, 'M/d/yy')}</Text>}
        </DetailsCard>
      )) || <></>
    );
  }
}

export default MoveInCosts;
